// Mock data for PickQuick landing page (no backend yet)
// This keeps all copy & structured content in one place for easier future wiring.

export const platforms = [
  { id: "blinkit", name: "Blinkit" },
  { id: "zepto", name: "Zepto" },
  { id: "instamart", name: "Swiggy Instamart" },
  { id: "jiomart", name: "JioMart" },
];

export const heroStats = [
  {
    id: "brands",
    label: "Category-leading brands",
    value: "25+",
  },
  {
    id: "speed",
    label: "Faster QC go-live",
    value: "3-5x",
  },
  {
    id: "pin",
    label: "Pincodes under management",
    value: "10K+",
  },
];

export const painPoints = [
  "Complex onboarding and approval cycles",
  "SKU mapping & cataloging across multiple platforms",
  "Pricing, compliance & visibility requirements",
  "Managing inventory across dark stores",
  "Distributor bandwidth & logistics constraints",
  "Lack of pincode-level demand visibility",
];

export const capabilities = [
  {
    id: "onboarding",
    title: "Fast, Seamless Onboarding",
    description:
      "Brand documentation, listings, compliance and PO-backed inventory handled in one flow.",
    tag: "Go-live in days",
  },
  {
    id: "sku-mapping",
    title: "Instant SKU Mapping & Cataloging",
    description:
      "Unified catalog optimized for conversion across Blinkit, Zepto, Instamart & JioMart.",
    tag: "Higher visibility",
  },
  {
    id: "inventory",
    title: "Inventory & Replenishment Management",
    description:
      "Predictive supply model that keeps the right stock in the right dark store at the right time.",
    tag: "Always in-stock",
  },
  {
    id: "logistics",
    title: "Logistics & Warehouse Coordination",
    description:
      "PO → dispatch → platform, fully synchronized with your distributors and warehouses.",
    tag: "Zero friction",
  },
  {
    id: "insights",
    title: "Real-Time Pincode Insights",
    description:
      "Sales, availability and demand tracked at store and pincode level for smarter decisions.",
    tag: "Data-first",
  },
  {
    id: "growth",
    title: "Platform Growth & Marketing Management",
    description:
      "Keyword strategy, visibility, promos and category-team collaboration handled for you.",
    tag: "Sustainable growth",
  },
];

export const processSteps = [
  {
    id: 1,
    title: "Fast Onboarding",
    subtitle: "All platforms, one setup",
    description:
      "We create your Quick Commerce presence across platforms with clean documentation and platform-backed confidence.",
  },
  {
    id: 2,
    title: "Instant Multi-Platform SKU Mapping",
    subtitle: "Unified, optimized catalog",
    description:
      "Your catalog is normalized, auto-mapped and optimized so priority SKUs go live first and convert better.",
  },
  {
    id: 3,
    title: "Real-Time Operational Intelligence",
    subtitle: "From visibility to action",
    description:
      "Pincode and dark-store analytics continuously feed replenishment, pricing and marketing decisions.",
  },
];

export const reasons = [
  {
    id: "speed",
    title: "Speed",
    description: "Deploy your products across QC platforms in days, not months.",
  },
  {
    id: "simplicity",
    title: "Simplicity",
    description: "One partner orchestrates your entire Quick Commerce lifecycle.",
  },
  {
    id: "reliability",
    title: "Reliability",
    description: "Optimized availability, reduced outages and proactive operations.",
  },
  {
    id: "insight",
    title: "Insight",
    description: "Pincode-level visibility into demand and consumer behavior.",
  },
  {
    id: "scale",
    title: "Scalability",
    description: "Grow from one city to state-wide or nationwide distribution effortlessly.",
  },
];

export const techFeatures = [
  "Real-time stock & availability tracking",
  "Automated PO processing",
  "Unified SKU mapping & catalog manager",
  "Dark-store level analytics",
  "Price, promo & performance dashboards",
  "Platform-level API integrations",
  "Operational alerts & replenishment signals",
];

export const brandProfiles = [
  "Category leaders in food, FMCG, staples & snacks",
  "High-frequency dairy, bakery and beverage brands",
  "Regional champions scaling to multi-city QC",
  "Everyday self-care and personal care brands",
];

export const faqItems = [
  {
    id: "timelines",
    question: "How fast can you get a brand live on Quick Commerce?",
    answer:
      "For brands with documentation ready, we typically enable presence across key platforms within 10-21 working days, depending on category and platform SLAs.",
  },
  {
    id: "commercials",
    question: "How do your commercials work?",
    answer:
      "PickQuick operates on outright purchase orders, not Sale-or-Return. When we mandate a brand, we evaluate SKUs, margins, and velocity, then issue a 12-month minimum revenue commitment in writing. We fund inventory, manage distribution and warehousing, run growth across the 13 platforms we operate on, including Blinkit, Zepto, Instamart and JioMart, and share a single consolidated dashboard. If we can't commit to revenue, we won't take the mandate, we evaluate 40+ brands a month and take on 8, 12. For a detailed commercial framework scoped to your category, book a 30-minute call.",
  },
  {
    id: "scope",
    question: "What all does PickQuick manage for us?",
    answer:
      "Onboarding, cataloging, inventory & replenishment coordination, logistics handshakes, platform growth and marketing ops, effectively a full QC operations stack.",
  },
  {
    id: "fit",
    question: "What type of brands are the best fit?",
    answer:
      "High-frequency consumer brands that already win offline, across food, FMCG, staples, snacks, dairy, bakery, beverages and self-care.",
  },
];

export const contactInfo = {
  email: "anuj@letspickquick.com",
  phone: "+91 87330 85863",
};
